import { useState, useEffect } from "react";
import { batch, useDispatch } from "react-redux";
import * as actionTypes from "../appStore/actions/ArkchatGroup/type";
import { clearCurrentAiSessionData, handleDeactivatePrivateChat, handleFetchConversation, handleFetchMessages, handleGetThreadMessage, handleSaveTempMsgData, handleTaskUpdate, handleUpdateMsgToDb, requestDeleteGroup, requestEditGroupName, uploadAttachment } from "../appStore/actions/ArkchatGroup/action";
import { deleteTopicData } from "../config/db";
import { profileUpdate } from "../appStore/actions/profile/action";
import { AccountLevelArkchatPermission, accountType, ApprovalStatus, GroupLevelArkchatPermission, MessageType, TaskStatus } from "../utils/constant";
import { getCookie } from "../config/cookie";
import { handleAppSelectedTopicToSaveMsg, handleHomeTabValue, handleScrollToBottom, handleShowAIScreen, saveSelectedAppGroupData} from "../appStore/actions/AppState/action";
import dayjs from "dayjs"; 
import { RECEIVED_THREAD_MESSAGES, UPDATE_EXISTING_MESSAGE_LIST } from "../appStore/actions/ArkchatGroup/type";
import { generateRandomIV, handleDecryptSingleMessageData, msgEncrypter } from "../utils/messageEncrypt";
import { showToastMsg } from "../appStore/actions/global/action";
import { groupExternalMember } from "../utils/externalMemberGroping";
import { useTranslation } from "react-i18next";
import useAppSelectors from "./useAppSelectors";
import session, { uploadFileCache } from "../utils/helper";

const useTabState = ({
  pubnub,
  setFilterChecked,
  setNewMessages,
  setisTopicOpen,
  newMessages,
  dmUserDeatils,
  isAddPeopledarwer,
  setAddpeopledarwer,
  handleCloseAddPeopleDrawer,
  groupname,
  setGroupname,
  setShowSidebar,
  setShareAiText,
  isShareAiText,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const { currentUserData, groupmemberdetails } = useAppSelectors();
  // const messageList = useSelector((state) => state?.arkchatgroup?.messageList);
  const [isSearchGroupInfoOpen, setIsSearchGroupInfoOpen] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [messageListType, setMessageListType] = useState("main");
  const [filteredMessageList, setFilteredMessageList] = useState([]);
  const [leaveCompleteTask, setLeaveCompleteTask] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [stepper, setStepper] = useState("user");
  const [initialopenDialog, setOpenInitialDialog] = useState(true);
  const [isGroupmenuOpen, setGroupmenuOpen] = useState(false);
  const [isEditGroupmenu, setEditGroupmenu] = useState(false);
  const [isDeleteGroupmenu, setDeletegroupmenu] = useState(false);
  const [delInputval, setdeleteInputVal] = useState("");
  const [delrequired, setDeleteRequired] = useState(false);
  const [isGroupmembermenu, setGroupMembermenu] = useState(false);
  const [isLanguageMenuOpen, setLanguageMenuOpen] = useState(false);
  const [isdateAndTimeModalOpen, setDatAndTimeModal] = useState(false);
  const [isMediaFilesOpen, setMediaFilesOpen] = useState(false);
  const [dateFormate, setDateFormate] = useState("");
  const [isYYMMDD, setYYMMDD] = useState(false);
  const [isMMDDYY, setMMDDYY] = useState(false);
  const [isDDMMYY, setDDMMYY] = useState(false);
  const [is24Hour, set24Hour] = useState(false);
  const [isNotificationpreferenceModalOpen, setNotificationpreferenceModal] =
    useState(false);
  const [isEmailChecked, setEmailChecked] = useState(false);
  const [isMobileChecked, setMobileChecked] = useState(false);
  const [msgType, setMessageType] = useState(0);
  const [attachment, setAttachment] = useState([]);
  const [isTaskTypeModalOpen, setIsTaskTypeModalOpen] = useState(false);
  const [isThreadTaskTypeModalOpen, setIsThreadTaskTypeModalOpen] =
    useState(false);
  const [isTaskUpdateTypeModalOpen, setIsTaskUpdateTypeModalOpen] =
    useState(false);
  const [taskModalDeatils, setTaskModalDeatils] = useState({});
  const [attachmentType, setAttachmenttype] = useState("");
  const [attachmentdrawer, setAttachmentDrawer] = useState({
    isYoutube: false,
    isGoogle: false,
    isfile: false,
    isArkchatExplore: false,
  });
  const [fileAttachment, setFileAttachment] = useState([]);
  const [currentTaskData, setCurrentTaskData] = useState({});
  const [replyParentMsg, setReplyParentMsg] = useState("");
  const [isdisableprivatchat, setdisableprivatechat] = useState(false);
  const [isPrivateDisableChat, setPrivateDisableChat] = useState(false);

  const [readStatusdrawer, setReadstatusdrawer] = useState(false);
  const [isPermissionModalOpen, setPermissionModal] = useState(false);
  const [isownershipright, setownershipright] = useState(false);

  const [taskButtonDrawer, setTaskButtonDrawer] = useState(null);
  const [aiQueryValue, setAiQueryValue] = useState("");
  const [tempAiQuery, setTempAiQuery] = useState("");
  const [showTempQuery, setShowTempQuery] = useState(false);
  const [showStaredAiHistory, setShowStaredAiHistory] = useState(false);
  const [selecteAnswer, setSelectedAnswer] = useState(null);
  const [queryParam, setQueryparam] = useState(null);
  const [selectRecipientsDrawerOpen, setSelectRecipientsDrawerOpen] =
    useState(false);
  const [selectedRecipients, setSelectedRecipients] = useState({
    selectedInternalRecipients: [],
    selectedExternalRecipients: [],
  });
  const [externalGroupMember, setExternalGroupMemebr] = useState({});

  // eslint-disable-next-line no-unused-vars
  const [taskAssignedUser, setTaskAssignedUser] = useState({});
  const [dueTime, setDueTime] = useState(
    dayjs().set("hour", 23).set("minute", 59).set("second", 0),
  );
  const [dueDate, setDueDate] = useState(dayjs());
  const [priority, setPriority] = useState(1);
  const [isRepeat, setRepeat] = useState(false);
  const [repeatType, setRepeatType] = useState(null);
  const [selecteRepeatEvery, setSelectedRepeatEvery] = useState(null);
  const [isTaskUpdateOpen, setTaskUpdateOpen] = useState(false);
  const [taskData, setTaskData] = useState({});
  const [updateTaskApprovalMsg, setUpdateTaskApprovalMsg] = useState("");
  const [checkedType, setCheckedType] = useState(null);
  const [progress, setProgress] = useState(0);
  const [isThreadOpen, setThreadOpen] = useState(false);
  const [isSubTaskSuggestionDrawerOpen, setSubTaskSuggestionDrawerOpen] =
    useState(false);
  const [
    isThreadScreenFromTaskApprovalTab,
    setIsThreadScreenFromTaskApprovalTab,
  ] = useState(null);
  const dispatch = useDispatch();
  const {
    selectedGroup,
    isAiScreenActive,
    accountLevelPeople,
    groupTopicData,
    selectedTopic,
    selectedTopicToSaveMsg,
    groupList,
    groupRecipientDetails,
    threadMsgList,
  } = useAppSelectors();
  const isThreadScreen = session.get("isThreadScreen");

  const externalGroupRecipient = groupRecipientDetails?.filter(
    (item) =>
      item?.targetSubscriberId !== currentUserData?.activeSubscriber?.id,
  );
  const externalGroupRecipientCompanyWiseData = groupExternalMember(
    externalGroupRecipient,
    true,
    appContent?.KEY34,
  );

  useEffect(() => {
    setPrivateDisableChat(
      !groupList?.find((item) => item?.id == selectedGroup?.id)
        ?.isPrivateChatOn,
    );
    setSelectedRecipients({
      selectedInternalRecipients: [],
      selectedExternalRecipients: [],
    });
    setPriority(1);
    // setDueTime(dayjs().set("hour", 23).set("minute", 59).set("second", 0));
    // setDueDate(dayjs("2024-05-12"));
    setTaskAssignedUser({});
    setExternalGroupMemebr({});
    setSelectRecipientsDrawerOpen(false);
    setMessageType(MessageType?.Message);
    setStepper("user");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGroup]);

  const handleSearchInputChange = (value, type) => {
    setMessageListType(type);
    if (type === "main") {
      setSearchInputValue(value);
    }
    if (type === "thread") {
      setSearchInputValue(value);
    }
  };

  // Debounced search function for smooth performance
  const debouncedSearch = (() => {
    let timeoutId;
    return (searchTerm, messages) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        performSearch(searchTerm, messages);
      }, 300); // 300ms delay for smooth typing
    };
  })();

  // Utility function to highlight search terms
  const highlightText = (text, searchTerm) => {
    if (!text || !searchTerm) return text;

    const regex = new RegExp(
      `(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
      "gi",
    );
    const parts = text.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? (
        <mark
          key={index}
          style={{
            backgroundColor: "#ffeb3b",
            padding: "0 2px",
            borderRadius: "2px",
          }}
        >
          {part}
        </mark>
      ) : (
        part
      ),
    );
  };

  // Perform the actual search
  const performSearch = (searchTerm, messages) => {
    //console.log("searchTermDetails", searchTerm, messages);
    // if (!searchTerm || !messages || messages.length === 0) {
    //   setFilteredMessageList([]);
    //   setIsSearching(false);
    //   return;
    // }
    // setIsSearching(true);
    // const searchLower = searchTerm.toLowerCase().trim();
    // const filtered = messages.filter((message) => {
    //   // Search in message content
    //   const messageContent = message?.message?.toLowerCase() || "";
    //   if (messageContent.includes(searchLower)) {
    //     return true;
    //   }
    //   // Search in translations
    //   if (message?.translations) {
    //     const translationValues = Object.values(message.translations);
    //     const hasTranslationMatch = translationValues.some((translation) =>
    //       translation?.toLowerCase().includes(searchLower)
    //     );
    //     if (hasTranslationMatch) {
    //       return true;
    //     }
    //   }
    //   // Search in sender name
    //   const senderName = message?.from?.name?.toLowerCase() || "";
    //   if (senderName.includes(searchLower)) {
    //     return true;
    //   }
    //   // Search in recipient names
    //   if (message?.to && Array.isArray(message.to)) {
    //     const hasRecipientMatch = message.to.some((recipient) =>
    //       recipient?.name?.toLowerCase().includes(searchLower)
    //     );
    //     if (hasRecipientMatch) {
    //       return true;
    //     }
    //   }
    //   // Search in assignee name (for tasks/approvals)
    //   const assigneeName = message?.assignee?.name?.toLowerCase() || "";
    //   if (assigneeName.includes(searchLower)) {
    //     return true;
    //   }
    //   // Search in file attachments
    //   if (message?.attachments && Array.isArray(message.attachments)) {
    //     const hasAttachmentMatch = message.attachments.some((attachment) => {
    //       const fileName = attachment?.name?.toLowerCase() || "";
    //       const fileLocation = attachment?.location?.toLowerCase() || "";
    //       return (
    //         fileName.includes(searchLower) || fileLocation.includes(searchLower)
    //       );
    //     });
    //     if (hasAttachmentMatch) {
    //       return true;
    //     }
    //   }
    //   // Search in thread heading
    //   const threadHeading = message?.thread_heading?.toLowerCase() || "";
    //   if (threadHeading.includes(searchLower)) {
    //     return true;
    //   }
    //   return false;
    // });
    // setFilteredMessageList(filtered);
    // setIsSearching(false);
  };

  // Memoize the current message list based on messageListType to prevent unnecessary re-renders
  // const currentMessageList = useMemo(() => {
  //   return messageListType === "main" ? messageList : threadMsgList;
  // }, [messageListType, messageList, threadMsgList]);

  // Effect to trigger search when searchInputValue or currentMessageList changes
  // useEffect(() => {
  //   if (searchInputValue) {
  //     debouncedSearch(searchInputValue, currentMessageList);
  //   } else {
  //     setFilteredMessageList([]);
  //     setIsSearching(false);
  //   }
  // }, [searchInputValue, currentMessageList]);

  const handleSearch = () => {
    setIsSearchGroupInfoOpen(!isSearchGroupInfoOpen);
    if (!isSearchGroupInfoOpen) {
      setSearchInputValue("");
      setFilteredMessageList([]);
    }
  };

  useEffect(() => {
    setDDMMYY(currentUserData?.dateFormat === "DD-MM-YY");
    setMMDDYY(currentUserData?.dateFormat === "MM-DD-YY");
    setYYMMDD(currentUserData?.dateFormat === "YY-MM-DD");
    setEmailChecked(currentUserData?.notifyOnEmail);
    setMobileChecked(currentUserData?.notifyOnMobile);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleCloseInitialDialog = () => {
    setOpenInitialDialog(false);
  };

  useEffect(() => {
    setGroupname(selectedGroup?.name);
  }, [selectedGroup]);

  useEffect(() => {
    if (!isThreadOpen) {
      session.set("isThreadScreen", false);
      dispatch({
        type: actionTypes.RECEIVED_THREAD_MESSAGES,
        payload: [],
      });
    }
    setReplyParentMsg("");
  }, [selectedGroup, isThreadOpen]);

  const handleSelectedGroupmenuClick = (item) => {
    switch (item) {
      case "edit":
        setEditGroupmenu(true);
        break;

      case "delete":
        setDeletegroupmenu(true);
        break;

      case "members":
        setGroupMembermenu(true);
        break;
      default:
        break;
    }
  };

  const handleSelectedGroupmenu = (selectedmenu) => {
    // setselectedgroupmenu(selectedmenu);
    handleSelectedGroupmenuClick(selectedmenu?.value);
  };

  const handleCloseMemberDrawer = () => {
    setGroupMembermenu(false);
  };

  const handleChange = (event, newValue) => {
    setFilterChecked([]);
    setShowSidebar(true);
    dispatch(handleHomeTabValue(newValue));
    dispatch(handleScrollToBottom(true));
  };

  const handleclickAttherate = (type) => {
    if (selectedGroup?.isGroup) {
      setMessageType(type);
      if (type === MessageType?.Task) {
        setSelectRecipientsDrawerOpen(true);
      }
      if (type === MessageType?.Approval) {
        setSelectRecipientsDrawerOpen(true);
      }
      if (type === MessageType?.Message) {
        // for private chat
        setSelectRecipientsDrawerOpen(true);
      }
    }
  };

  const handleCloseUserChatAttach = () => {
    setSelectRecipientsDrawerOpen(false);
  };

  const handleOpenGroupDrawer = () => {
    if (selectedGroup && (selectedGroup?.isGroup || !selectedGroup?.isGroup)) {
      setGroupmenuOpen(true);
    }
  };

  const handleCloseGroupMenu = () => {
    setGroupmenuOpen(false);
    // setselectedgroupmenu(null);
  };
  const handleLanguageCloseMenu = () => {
    setLanguageMenuOpen(false);
  };

  const handleOnChangeNewMessage = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      setNewMessages((prevMessages) => prevMessages + "\n");
    } else {
      setNewMessages(event.target.value);
    }
  };

  const handleOnInputChange = (event) => {
    setGroupname(event.target.value);
  };

  const handleOnDeleteInput = (event) => {
    setdeleteInputVal(event.target.value);
  };

  const handleDeleteGroup = async () => {
    if (delInputval) {
      if (delInputval === "DELETE") {
        setDeletegroupmenu(false);
        setdeleteInputVal("");
        await dispatch(requestDeleteGroup(selectedGroup?.id));
        deleteTopicData(selectedGroup?.id,"groupId");
        //////
        handleCloseGroupMenu();
      } else {
      }
    } else {
      setDeleteRequired(true);
    }
  };

  const handleUpdateGroupname = async () => {
    const reqBody = {
      group_name: groupname,
      description: selectedGroup?.description,
    };
    if (groupname) {
      setEditGroupmenu(false);
      setGroupname("");
      dispatch(requestEditGroupName(selectedGroup?.id, reqBody)).then(
        (response) => {
          if (response?.data?.status) {
          } else {
            setGroupname(selectedGroup?.name);
            dispatch(saveSelectedAppGroupData(selectedGroup));
            setisTopicOpen(true);
          }
        },
      );
      handleCloseGroupMenu();
    }
  };

  const handleAddgroupMember = () => {
    if (selectedGroup && selectedGroup?.isGroup) {
      setAddpeopledarwer(true);
    }
  };

  const handleDateTimeUpdate = () => {
    if (dateFormate || is24Hour || !is24Hour) {
      const reqBody = {
        date_format: dateFormate ? dateFormate : currentUserData?.dateFormat,
        time_format: is24Hour ? "24" : "12",
      };
      dispatch(profileUpdate(reqBody)).then((res) => {
        if (res?.status) {
          setDatAndTimeModal(false);
        }
      });
    }
  };

  const handleNotificationPreference = () => {
    if (isEmailChecked || isMobileChecked) {
      const reqBody = {
        notify_on_email: isEmailChecked,
        notify_on_mobile: isMobileChecked,
      };
      dispatch(profileUpdate(reqBody)).then((res) => {
        if (res?.status) {
          setNotificationpreferenceModal(false);
        }
      });
    }
  };

  const handleClickTaskUpdate = (taskData) => {
    setCurrentTaskData(taskData);
    if (
      taskData?.assignee?.id === currentUserData?.id ||
      taskData?.from?.id === currentUserData?.id ||
      currentUserData?.activePermission === AccountLevelArkchatPermission?.ADMIN
    ) {
      if (!taskData?.id) {
        const reqBody = {
          pn_id: selectedGroup?.pnId,
          timetoken: [taskData?.temp_timetoken],
        };
        dispatch(handleFetchConversation(reqBody)).then((res) => {
          const decryptedData = handleDecryptSingleMessageData(res[0]?.message);
          setTaskData(decryptedData);
          setReplyParentMsg(decryptedData);
          setPriority(decryptedData?.priority);
          setMessageType(decryptedData?.type);
          setDueTime(dayjs(decryptedData?.due_time, "HH:mm"));
          setDueDate(dayjs(decryptedData?.due_date));
          setTaskUpdateOpen(true);
          dispatch(handleUpdateMsgToDb(decryptedData));
        });
      }
      if (currentUserData?.id && taskData?.id) {
        setReplyParentMsg(taskData);
        setTaskData(taskData);
        setPriority(taskData?.priority);
        setMessageType(taskData?.type);
        setDueTime(dayjs(taskData?.due_time, "HH:mm"));
        setDueDate(dayjs(taskData?.due_date));
        setTaskUpdateOpen(true);
      }
    }
  };

  const handleDmMsgLogic = async (dmUserDetails, initReqBody) => {
    const dmUserData = [
      ...accountLevelPeople?.externalMember,
      ...accountLevelPeople?.internalMember,
    ]?.filter((data) => data?.userId === dmUserDetails?.id);

    initReqBody.messageType = 3;
    initReqBody.priority = 0;
    dmUserData[0]?.userId !== currentUserData?.id &&
      initReqBody.recipients.push({
        id: dmUserData[0]?.userId,
        pp: dmUserData[0]?.userInfo?.profileImgUrl,
        name: `${dmUserData[0]?.userInfo?.firstName} ${dmUserData[0]?.userInfo?.lastName}`,
        target_subscriber_id: dmUserData[0]?.userInfo?.activeSubscriber?.id,
        languageCode: dmUserData[0]?.languageCode,
      });

    initReqBody.recipients.push({
      id: currentUserData?.id,
      pp: currentUserData?.profileImgUrl,
      name: `${currentUserData?.firstName} ${currentUserData?.lastName}`,
      target_subscriber_id: currentUserData?.activeSubscriber?.id,
      languageCode: currentUserData?.languageCode,
    });
  };

  const handleSendMsgToAllGroupMember = (initReqBody) => {
    initReqBody.topic_id = selectedTopicToSaveMsg
      ? selectedTopicToSaveMsg?.id
      : groupTopicData?.data[0]?.id;
    initReqBody.group_subscriber_id = selectedGroup?.subscriberId;
    initReqBody.group_id = selectedGroup?.id;
    initReqBody.is_all_group_member = true;

    // Use a Set to track unique recipient IDs
    const recipientSet = new Set();

    const addRecipient = (recipient) => {
      const identifier = `${recipient.id}`;
      if (!recipientSet.has(identifier)) {
        recipientSet.add(identifier);
        initReqBody.recipients.push(recipient);
      }
    };

    // For internal members
    [...groupmemberdetails?.internalMember]?.forEach((item) => {
      if (
        item?.permission === AccountLevelArkchatPermission?.ADMIN ||
        item?.permissionType !== GroupLevelArkchatPermission?.REMOVE
      ) {
        addRecipient({
          id: item?.userId,
          pp: item?.userInfo?.profileImgUrl,
          name: `${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`,
          target_subscriber_id: item?.subscriberId,
          languageCode: item?.languageCode,
        });
      }
    });

    // For external members
    externalGroupRecipient?.forEach((item) => {
      if (currentUserData?.activeSubscriber?.id !== item?.targetSubscriberId) {
        addRecipient({
          id: item?.userId,
          pp: item?.profileImgUrl,
          name: `${item?.firstName} ${item?.lastName}`,
          target_subscriber_id: item?.targetSubscriberId,
          languageCode: item?.languageCode,
        });
      }
    });
  };

  const handleGroupPrivateMsgLogic = async (initReqBody) => {
    initReqBody.topic_id = selectedTopicToSaveMsg?.id
      ? selectedTopicToSaveMsg?.id
      : groupTopicData?.data[0]?.id;
    initReqBody.group_subscriber_id = selectedGroup?.subscriberId;
    initReqBody.group_id = selectedGroup?.id;
    initReqBody.is_all_group_member =
      [
        ...selectedRecipients?.selectedInternalRecipients,
        ...selectedRecipients?.selectedExternalRecipients,
      ]?.length === groupRecipientDetails?.length
        ? true
        : false;

    // Use a Set to track unique recipient IDs
    const recipientSet = new Set();

    const addRecipient = (recipient) => {
      const identifier = `${recipient.id}`;
      if (!recipientSet.has(identifier)) {
        recipientSet.add(identifier);
        initReqBody.recipients.push(recipient);
      }
    };

    // For internal member users only (non-admins)
    [...selectedRecipients?.selectedInternalRecipients]?.forEach((item) => {
      let prmesion = item?.permission || item?.accountPermission;
      let profilePic = item?.userInfo
        ? item?.userInfo?.profileImgUrl
        : item?.profileImgUrl;
      let userName = item?.userInfo
        ? `${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`
        : `${item?.firstName} ${item?.lastName}`;
      let targetSubId = item?.userInfo
        ? item?.subscriberId
        : item?.targetSubscriberId;
      if (
        prmesion !== AccountLevelArkchatPermission?.ADMIN &&
        item?.userId !== currentUserData?.id
      ) {
        addRecipient({
          id: item?.userId,
          pp: profilePic,
          name: userName,
          target_subscriber_id: targetSubId,
          languageCode: item?.languageCode,
        });
      }
    });

    // For internal members who are admins, owners, etc.
    [...groupmemberdetails?.internalMember]?.forEach((item) => {
      if (
        item?.permission === AccountLevelArkchatPermission?.ADMIN &&
        item?.userId !== currentUserData?.id
      ) {
        addRecipient({
          id: item?.userId,
          pp: item?.userInfo?.profileImgUrl,
          name: `${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`,
          target_subscriber_id: item?.subscriberId,
          languageCode: item?.languageCode,
        });
      }
    });

    // For external members
    [...selectedRecipients?.selectedExternalRecipients]?.forEach((item) => {
      if (
        (item?.accountPermission !== AccountLevelArkchatPermission?.ADMIN ||
          item?.subscriberPriority === accountType?.Individual) &&
        item?.userId !== currentUserData?.id
      ) {
        addRecipient({
          id: item?.userId,
          pp: item?.profileImgUrl,
          name: `${item?.firstName} ${item?.lastName}`,
          target_subscriber_id: item?.targetSubscriberId,
          languageCode: item?.languageCode,
        });
      }
    });

    // For external group recipients based on company
    externalGroupRecipientCompanyWiseData?.forEach((company) => {
      if (
        externalGroupMember[Object.keys(company)[0]]?.length > 0 &&
        Object.values(company)[0][0]?.subscriberPriority !==
          accountType?.Individual
      ) {
        Object.values(company)[0]?.forEach((item) => {
          if (
            item?.accountPermission === AccountLevelArkchatPermission?.ADMIN &&
            item?.userId !== currentUserData?.id
          ) {
            addRecipient({
              id: item?.userId,
              pp: item?.profileImgUrl,
              name: `${item?.firstName} ${item?.lastName}`,
              target_subscriber_id: item?.targetSubscriberId,
              languageCode: item?.languageCode,
            });
          }
        });
      }
    });

    if (isThreadScreen) {
      threadMsgList?.[0]?.to?.forEach((item) => addRecipient(item));
    }

    // Add the user sending the message
    addRecipient({
      id: currentUserData?.id,
      pp: currentUserData?.profileImgUrl,
      name: `${currentUserData?.firstName} ${currentUserData?.lastName}`,
      target_subscriber_id: currentUserData?.activeSubscriber?.id,
      languageCode: currentUserData?.languageCode,
    });
  };

  const handleTaskApprovalMsgLogic = async (initReqBody) => {
    initReqBody.topic_id = selectedTopicToSaveMsg?.id
      ? selectedTopicToSaveMsg?.id
      : groupTopicData?.data[0]?.id;
    initReqBody.group_subscriber_id = selectedGroup?.subscriberId;
    initReqBody.group_id = selectedGroup?.id;
    msgType === MessageType?.Task
      ? (initReqBody.task_status = TaskStatus?.Pending)
      : (initReqBody.approval_status = ApprovalStatus?.Pending);
    initReqBody.messageType =
      msgType === MessageType?.Task ? MessageType?.Task : MessageType?.Approval;
    initReqBody.due_date = dueDate.format("YYYY-MM-DD");
    initReqBody.due_time = dueTime.format("HH:mm");
    initReqBody.priority = priority;
    initReqBody.repeat = repeatType;
    initReqBody.repeat_every = selecteRepeatEvery;
    initReqBody.repeatable = isRepeat;
    initReqBody.is_all_group_member =
      [
        ...selectedRecipients?.selectedInternalRecipients,
        ...selectedRecipients?.selectedExternalRecipients,
      ]?.length === groupRecipientDetails?.length
        ? true
        : false;

    // Use a Set to track unique recipient IDs
    const recipientSet = new Set();

    const addRecipient = (recipient) => {
      const identifier = `${recipient.id}`;
      if (!recipientSet.has(identifier)) {
        recipientSet.add(identifier);
        initReqBody.recipients.push(recipient);
      }
    };

    // For internal users only (non-admins)
    [...selectedRecipients?.selectedInternalRecipients]?.forEach((item) => {
      let permission = item?.permission || item?.accountPermission;
      let profilePic = item?.userInfo
        ? item?.userInfo?.profileImgUrl
        : item?.profileImgUrl;
      let userName = item?.userInfo
        ? `${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`
        : `${item?.firstName} ${item?.lastName}`;
      let targetSubId = item?.userInfo
        ? item?.subscriberId
        : item?.targetSubscriberId;

      if (
        permission !== AccountLevelArkchatPermission?.ADMIN &&
        item?.userId !== taskAssignedUser?.userId &&
        item?.userId !== currentUserData?.id
      ) {
        addRecipient({
          id: item?.userId,
          pp: profilePic,
          name: userName,
          target_subscriber_id: targetSubId,
          languageCode: item?.languageCode,
        });
      }
    });

    // For internal members who are admins, owners, etc.
    [...groupmemberdetails?.internalMember]?.forEach((item) => {
      if (
        item?.permission === AccountLevelArkchatPermission?.ADMIN &&
        item?.userId !== taskAssignedUser?.userId &&
        item?.userId !== currentUserData?.id
      ) {
        addRecipient({
          id: item?.userId,
          pp: item?.userInfo?.profileImgUrl,
          name: `${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`,
          target_subscriber_id: item?.subscriberId,
          languageCode: item?.languageCode,
        });
      }
    });

    // For external members
    [...selectedRecipients?.selectedExternalRecipients]?.forEach((item) => {
      if (
        (item?.accountPermission !== AccountLevelArkchatPermission?.ADMIN ||
          item?.subscriberPriority === accountType?.Individual) &&
        item?.userId !== taskAssignedUser?.userId &&
        item?.userId !== currentUserData?.id
      ) {
        addRecipient({
          id: item?.userId,
          pp: item?.profileImgUrl,
          name: `${item?.firstName} ${item?.lastName}`,
          target_subscriber_id: item?.targetSubscriberId,
          languageCode: item?.languageCode,
        });
      }
    });

    // For external group recipients based on company
    externalGroupRecipientCompanyWiseData?.forEach((company) => {
      if (
        externalGroupMember[Object.keys(company)[0]]?.length > 0 &&
        Object.values(company)[0][0]?.subscriberPriority !==
          accountType?.Individual
      ) {
        Object.values(company)[0]?.forEach((item) => {
          if (
            item?.accountPermission === AccountLevelArkchatPermission?.ADMIN &&
            item?.userId !== taskAssignedUser?.userId &&
            item?.userId !== currentUserData?.id
          ) {
            addRecipient({
              id: item?.userId,
              pp: item?.profileImgUrl,
              name: `${item?.firstName} ${item?.lastName}`,
              target_subscriber_id: item?.targetSubscriberId,
              languageCode: item?.languageCode,
            });
          }
        });
      }
    });

    if (isThreadScreen || ((taskModalDeatils?.msgType === MessageType?.ApproveAndAskApproval || taskModalDeatils?.msgType === MessageType?.RejectAndAskApproval) && msgType === MessageType?.Approval)
    ){
      threadMsgList?.[0]?.to?.forEach((item) => addRecipient(item));
    }

    // Add the user assigned to the task
    addRecipient(
      {
        id: taskAssignedUser?.userId,
        pp: taskAssignedUser?.profileImgUrl,
        name: `${taskAssignedUser?.firstName} ${taskAssignedUser?.lastName}`,
        target_subscriber_id: taskAssignedUser?.targetSubscriberId,
        languageCode: taskAssignedUser?.languageCode,
      },
      "taksAss",
    );

    // Add the current user if they are not the assigned user
    if (taskAssignedUser?.userId !== currentUserData?.id) {
      addRecipient(
        {
          id: currentUserData?.id,
          pp: currentUserData?.profileImgUrl,
          name: `${currentUserData?.firstName} ${currentUserData?.lastName}`,
          target_subscriber_id: currentUserData?.activeSubscriber?.id,
          languageCode: currentUserData?.languageCode,
        },
        "crnt",
      );
    }

    // Set the assigned user details
    initReqBody.assignedTo = {
      id: taskAssignedUser?.userId,
      pp: taskAssignedUser?.profileImgUrl,
      name: `${taskAssignedUser?.firstName} ${taskAssignedUser?.lastName}`,
      target_subscriber_id: taskAssignedUser?.targetSubscriberId,
      languageCode: taskAssignedUser?.languageCode,
    };
  };

  const handleResetState = () => {
    setCurrentTaskData({});
    setReplyParentMsg("");
    setAttachment([]);
    setFileAttachment([]);
    setNewMessages("");
    setSelectedRecipients({
      selectedInternalRecipients: [],
      selectedExternalRecipients: [],
    });
    setTaskData({});
    setExternalGroupMemebr({});
    dispatch(clearCurrentAiSessionData());
    dispatch(handleShowAIScreen(false));
    setTempAiQuery(false);
    setShareAiText(false);
    setSelectRecipientsDrawerOpen(false);
    setMessageType(MessageType?.Message);
    setDueDate(dayjs());
    setDueTime(dayjs().set("hour", 23).set("minute", 59).set("second", 0));
    setSelectedRepeatEvery(null);
    setRepeatType(null);
    setRepeat(false);
    setPriority(1);
    setTaskAssignedUser({});
    setStepper("user");
    setTaskUpdateOpen(false);
    setCheckedType(null);
    setUpdateTaskApprovalMsg("");
    dispatch(handleAppSelectedTopicToSaveMsg(selectedTopic));
  };

  const readFileAsDataURL = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () =>
        resolve({
          dataURL: reader.result,
          name: file.name,
          size: file.size,
        });
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const handleSendTempMsg = async (reqBoby) => {
    const { pnId, ...requestBodyWithoutPnId } = reqBoby;
    // console.log(reqBoby)
    let publishMessageFormat;
    let encryptedMsgBody = encryptPendingMsg(requestBodyWithoutPnId);
    // if (reqBoby?.type === MessageType?.Message && !reqBoby?.thread_id) {
    //   publishMessageFormat = {
    //     type: "message",
    //     content: {
    //       message: encryptedMsgBody,
    //       type: "conversation-message",
    //     },
    //     token: getCookie("token"),
    //   };
    // } else if (reqBoby?.type === MessageType?.Message && reqBoby?.thread_id) {
    //   publishMessageFormat = {
    //     type: "message",
    //     content: {
    //       message: encryptedMsgBody,
    //       type: "message-thread",
    //     },
    //     token: getCookie("token"),
    //   };
    // } else if (
    //   reqBoby?.type === MessageType?.Direct_Mesage &&
    //   !reqBoby?.thread_id
    // ) {
    //   publishMessageFormat = {
    //     type: "message",
    //     content: {
    //       message: encryptedMsgBody,
    //       type: "direct-message",
    //     },
    //     token: getCookie("token"),
    //   };
    // }
    // if (navigator.onLine) {
    //   logWrapper(publishMessageFormat, ":><:><:22");
    //   pubnub
    //     .publish({
    //       channel: selectedGroup?.pnId,
    //       message: publishMessageFormat,
    //     })
    //     .catch((error) => {
    //       // Handle publish error here
    //       dispatch(showToastMsg("Failed to publish message"));
    //     });
    // }
  };

  const handleMessageSend = async (approvalToReqBody = {}) => {
    const initReqBody = {
      message:
        (taskModalDeatils?.msgType === MessageType?.ApproveAndAskApproval ||
          taskModalDeatils?.msgType === MessageType?.RejectAndAskApproval || 
          taskModalDeatils?.msgType === MessageType?.RequestApprovalOnTask) &&
        msgType === MessageType?.Approval
          ? updateTaskApprovalMsg
          : newMessages,
      group_subscriber_id: 0,
      topic_id: 0,
      messageType: 0,
      from: {
        id: currentUserData?.id,
        name: `${currentUserData?.firstName} ${currentUserData?.lastName}`,
        pp: currentUserData?.profileImgUrl,
        target_subscriber_id: currentUserData?.activeSubscriber?.id,
        languageCode: currentUserData?.languageCode,
      },
      recipients: [],
      group_id: 0,
      subscriber_id: currentUserData?.activeSubscriber?.id,
      assignedTo: null,
      task_status: 0,
      approval_status: 0,
      due_date: null,
      repeatable: false,
      repeat: null,
      repeat_every: null,
      priority: 1,
      due_time: null,
      attachments: [],
      is_all_group_member: false,
      ai: isAiScreenActive ? true : false,
      estimated_time: {},
      start_time: 0,
      actual_time: {},
      end_time: 0,
    };

    if (dmUserDeatils && !selectedGroup?.isGroup) {
      handleDmMsgLogic(dmUserDeatils, initReqBody);
    } else {
      if (taskModalDeatils?.msgType === MessageType?.ApproveAndAskApproval && msgType === MessageType?.Approval
      ) {
        handleTaskApprovalMsgLogic(initReqBody);
      } else if (msgType === MessageType?.Message && (selectedRecipients?.selectedInternalRecipients?.length > 0 || selectedRecipients?.selectedExternalRecipients?.length > 0 || isThreadScreen)
      ) {
        handleGroupPrivateMsgLogic(initReqBody);
      } else if (msgType === MessageType?.Task || msgType === MessageType?.Approval
      ) {
        handleTaskApprovalMsgLogic(initReqBody);
      } else {
        handleSendMsgToAllGroupMember(initReqBody);
      }
    }

    const kuncikaR = generateRandomIV().toString();
    let reqbody = {
      message: msgEncrypter.encrypt(
        initReqBody?.message,
        process.env.REACT_APP_ENC_KEY,
        kuncikaR,
      ),
      kuncika: kuncikaR,
      group_subscriber_id: initReqBody?.group_subscriber_id || null,
      to: initReqBody?.recipients,
      subscriber_id: initReqBody?.subscriber_id,
      group_id: initReqBody?.group_id,
      topic_id: initReqBody?.topic_id,
      type: initReqBody?.messageType,
      from: initReqBody?.from,
      assignee: initReqBody?.assignedTo,
      task_status: initReqBody?.task_status,
      approval_status: initReqBody?.approval_status,
      due_date: initReqBody?.due_date,
      attachments:
        attachmentType === "serachedLinks"
          ? attachment
          : initReqBody?.attachments,
      repeat_every: initReqBody?.repeat_every,
      repeat: initReqBody?.repeat,
      ai: isAiScreenActive ? true : false,
      priority: initReqBody?.priority,
      due_time: initReqBody?.due_time,
      repeatable: initReqBody?.repeatable,
      is_all_group_member: initReqBody?.is_all_group_member,
      is_main: true,
      temp_timetoken: `temp.${selectedGroup?.pnId}.${currentUserData?.id}.${
        Math.floor(new Date().getTime()) * 1000
      }`,
    };

    const newReqBody = {
      ...reqbody,
      pnId: selectedGroup?.pnId,
      is_main: true,
    };
    if ((taskModalDeatils?.msgType === MessageType?.ApproveAndAskApproval || taskModalDeatils?.msgType === MessageType?.RejectAndAskApproval || taskModalDeatils?.msgType === MessageType?.RequestApprovalOnTask) && msgType === MessageType?.Approval
    ) {
      newReqBody.thread_id = approvalToReqBody?.thread_id
        ? approvalToReqBody?.thread_id
        : approvalToReqBody?.id || null;
      newReqBody.topic_id = approvalToReqBody?.topic_id;
      newReqBody.thread_original_message = replyParentMsg?.id
        ? {
            id: replyParentMsg?.id,
            message: msgEncrypter.encrypt(
              replyParentMsg?.message,
              process.env.REACT_APP_ENC_KEY,
              newReqBody?.kuncika,
            ),
            temp_timetoken: replyParentMsg?.temp_timetoken,
            timetoken: replyParentMsg?.timetoken,
            translations: msgEncrypter.encrypt(
              JSON.stringify(replyParentMsg?.translations),
              process.env.REACT_APP_ENC_KEY,
              newReqBody?.kuncika,
            ),
          }
        : null;
      newReqBody.chain = approvalToReqBody?.chain;
      newReqBody.nhi_nhi = true;
    }

    if (isThreadScreen) {
      newReqBody.thread_id =
        threadMsgList?.length > 0
          ? threadMsgList[0]?.thread_id
            ? threadMsgList[0]?.thread_id
            : threadMsgList[0]?.id
          : null;
      newReqBody.topic_id = threadMsgList[0]?.topic_id;
      newReqBody.thread_original_message = replyParentMsg?.id
        ? {
            id: replyParentMsg?.id,
            message: msgEncrypter.encrypt(
              replyParentMsg?.message,
              process.env.REACT_APP_ENC_KEY,
              newReqBody?.kuncika,
            ),
            temp_timetoken: replyParentMsg?.temp_timetoken,
            timetoken: replyParentMsg?.timetoken,
            translations: msgEncrypter.encrypt(
              JSON.stringify(replyParentMsg?.translations),
              process.env.REACT_APP_ENC_KEY,
              newReqBody?.kuncika,
            ),
          }
        : null;
    }
    handleResetState();
    const formData = new FormData();
    let responseFilesData = [];
    const fileRefs = [];

    if (fileAttachment.length > 0) {
      fileAttachment.forEach((file) => {
        const tempId = Date.now();
        uploadFileCache.set(tempId, file.file);

        fileRefs.push({
          id: tempId,
          name: file.file.name,
          size: file.file.size,
          type: file.file.type,
        });

        formData.append("files", file.file);
      });
    }

    fileAttachment.length > 0
      ? dispatch(
          handleSaveTempMsgData(
            { ...newReqBody, fileData:fileRefs },
            selectedGroup?.pnId,
            "sendMsg",
          ),
        )
      : dispatch(
          handleSaveTempMsgData(newReqBody, selectedGroup?.pnId, "sendMsg"),
        );

    if (fileAttachment.length > 0 && navigator.onLine) {
      await dispatch(
        uploadAttachment(formData, selectedGroup?.pnId, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
            setProgress(percentCompleted);
          },
        }),
      ).then((res) => {
        responseFilesData = res;
        setProgress(0);
        setFileAttachment([]);
      });
    }

    // Update reqbody with the uploaded file data
    if (responseFilesData?.length > 0) {
      fileRefs.forEach((f) => {
      uploadFileCache.delete(f.id);
      });
      reqbody.attachments = responseFilesData;
    }

    let publishMessageFormat;
    //console.log("REQBODYTHREADYLIST",threadMsgList)
    if (selectedGroup?.isGroup) {
      if (isThreadScreen) {
        publishMessageFormat = {
          type: "message",
          content: {
            message: {
              ...reqbody,
              is_main: false,
              nhi_nhi:
                taskModalDeatils?.msgType === MessageType?.AssignSubTask
                  ? true
                  : false,
              attachments:
                responseFilesData.length > 0
                  ? responseFilesData
                  : reqbody.attachments,
              topic_id: threadMsgList[0]?.topic_id,
              thread_id:
                threadMsgList.length > 0 && threadMsgList[0]?.thread_id
                  ? threadMsgList[0]?.thread_id
                  : threadMsgList[0]?.id,
              thread_original_message: replyParentMsg?.id
                ? {
                    id: replyParentMsg?.id,
                    message: msgEncrypter.encrypt(
                      replyParentMsg.message,
                      process.env.REACT_APP_ENC_KEY,
                      reqbody.kuncika,
                    ),
                    temp_timetoken: replyParentMsg.temp_timetoken,
                    timetoken: replyParentMsg.timetoken,
                    translations: msgEncrypter.encrypt(
                      JSON.stringify(replyParentMsg.translations),
                      process.env.REACT_APP_ENC_KEY,
                      reqbody.kuncika,
                    ),
                  }
                : null,
              is_private: reqbody.is_all_group_member ? false : true,
            },
            type: "message-thread",
          },
          token: getCookie("token"),
          is_private: reqbody.is_all_group_member ? false : true,
        };
      } else if (
        (taskModalDeatils?.msgType === MessageType?.ApproveAndAskApproval ||
          taskModalDeatils?.msgType === MessageType?.RejectAndAskApproval ||
          taskModalDeatils?.msgType === MessageType?.RequestApprovalOnTask) &&
        msgType === MessageType?.Approval
      ) {
        publishMessageFormat = {
          type: "message",
          content: {
            message: {
              ...reqbody,
              attachments:
                responseFilesData.length > 0
                  ? responseFilesData
                  : reqbody.attachments,
              topic_id: approvalToReqBody?.topic_id,
              thread_id: approvalToReqBody?.thread_id
                ? approvalToReqBody?.thread_id
                : approvalToReqBody?.id,
              thread_original_message: replyParentMsg?.id
                ? {
                    id: replyParentMsg?.id,
                    message: msgEncrypter.encrypt(
                      replyParentMsg.message,
                      process.env.REACT_APP_ENC_KEY,
                      reqbody.kuncika,
                    ),
                    temp_timetoken: replyParentMsg.temp_timetoken,
                    timetoken: replyParentMsg.timetoken,
                    translations: msgEncrypter.encrypt(
                      JSON.stringify(replyParentMsg.translations),
                      process.env.REACT_APP_ENC_KEY,
                      reqbody.kuncika,
                    ),
                  }
                : null,
              is_private: reqbody.is_all_group_member ? false : true,
              chain: approvalToReqBody?.chain,
              nhi_nhi: approvalToReqBody?.nhi_nhi || false,
            },
            type: "message-thread",
          },
          token: getCookie("token"),
          is_private: reqbody.is_all_group_member ? false : true,
        };
      } else {
        publishMessageFormat = {
          type: "message",
          content: {
            message: {
              ...reqbody,
              attachments:
                responseFilesData.length > 0
                  ? responseFilesData
                  : reqbody.attachments,
              is_private: reqbody.is_all_group_member ? false : true,
            },
            type: "conversation-message",
          },
          token: getCookie("token"),
          is_private: reqbody.is_all_group_member ? false : true,
        };
      }
    } else {
      publishMessageFormat = {
        type: "message",
        content: {
          message: {
            ...reqbody,
            attachments:
              responseFilesData.length > 0
                ? responseFilesData
                : reqbody.attachments,
            thread_original_message: replyParentMsg?.id
              ? {
                  id: replyParentMsg?.id,
                  message: msgEncrypter.encrypt(
                    replyParentMsg.message,
                    process.env.REACT_APP_ENC_KEY,
                    reqbody.kuncika,
                  ),
                  temp_timetoken: replyParentMsg.temp_timetoken,
                  timetoken: replyParentMsg.timetoken,
                  translations: msgEncrypter.encrypt(
                    JSON.stringify(replyParentMsg.translations),
                    process.env.REACT_APP_ENC_KEY,
                    reqbody.kuncika,
                  ),
                }
              : null,
          },
          type: "direct-message",
        },
        token: getCookie("token"),
      };
    }
    console.log(publishMessageFormat, "publishMessageFormat");

    if (navigator.onLine) {
      pubnub
        .publish({
          channel: publishMessageFormat?.is_private
            ? `${selectedGroup?.pnId}.user_${currentUserData?.id}`
            : selectedGroup?.pnId,
          message: publishMessageFormat,
        })
        .catch((error) => {
          // Handle publish error here
          dispatch(showToastMsg("Something went wrong please try again!"));
        });
    } else {
      dispatch(handleSaveTempMsgData(newReqBody, selectedGroup?.pnId));
      setFileAttachment([]);
    }
  };

  const handlegetThreadMessages = async (item, isRepliedClicked = true) => {
    try {
      setSearchInputValue("");
      setNewMessages("");

      const isTempMessage = !item?.id;
      let messageData = item;
      if (isTempMessage) {
        const reqBody = {
          pn_id: selectedGroup?.pnId,
          timetoken: [item.temp_timetoken],
        };

        const res = await dispatch(handleFetchConversation(reqBody));
        if (res?.length > 0) {
          messageData = handleDecryptSingleMessageData(res[0]?.message);
        }
      }

      if (isRepliedClicked) {
        setReplyParentMsg(messageData);

        if (isTempMessage) {
          dispatch({
            type: UPDATE_EXISTING_MESSAGE_LIST,
            payload: messageData,
          });

          dispatch(handleUpdateMsgToDb(messageData));
        }
      }

      await dispatch(handleGetThreadMessage(messageData));

      setThreadOpen(true);
      batch(() => {
        dispatch(handleScrollToBottom(true));
        session.set("isThreadScreen", true);
        // dispatch(handleOpenCloseThreadView(true));
      });
    } catch (error) {
      console.error("handlegetThreadMessages error:", error);
    }
  };

  const handleViewThreadClickTaskApprovalTab = (item, tabValue) => {
    // dispatch(handleHomeTabValue(0));
    handlegetThreadMessages(item, false, tabValue);
  };

  const encryptPendingMsg = (msgData) => {
    let encryptedMsgBody;
    if (
      msgData?.thread_original_message &&
      msgData?.thread_original_message?.id
    ) {
      // msgEncrypter.encrypt(
      //   replyParentMsg?.message,
      //   process.env.REACT_APP_ENC_KEY,
      //   "your-32-length-s"
      // ),
      encryptedMsgBody = {
        ...msgData,
        message: msgEncrypter.encrypt(
          msgData?.message,
          process.env.REACT_APP_ENC_KEY,
          "your-32-length-s",
        ),
        thread_original_message: {
          ...msgData?.thread_original_message,
          message: msgEncrypter.encrypt(
            msgData?.thread_original_message?.message,
            process.env.REACT_APP_ENC_KEY,
            "your-32-length-s",
          ),

          translations: msgEncrypter.encrypt(
            JSON.stringify(msgData?.thread_original_message?.translations),
            process.env.REACT_APP_ENC_KEY,
            "your-32-length-s",
          ),
        },
      };
    } else {
      encryptedMsgBody = {
        ...msgData,
        message: msgEncrypter.encrypt(
          msgData?.message,
          process.env.REACT_APP_ENC_KEY,
          "your-32-length-s",
        ),
      };
    }
    return encryptedMsgBody;
  };

  const buildTaskApprovalReqBody = ({initReqBody, taskStatus, body, updateTaskApprovalMsg, kuncikaR,}) => {
    const reqBody = {
      message: msgEncrypter.encrypt(
        initReqBody?.message,
        process.env.REACT_APP_ENC_KEY,
        kuncikaR,
      ),
      kuncika: kuncikaR,
      group_subscriber_id: initReqBody?.group_subscriber_id,
      to: initReqBody?.recipients,
      subscriber_id: initReqBody?.subscriber_id,
      group_id: initReqBody?.group_id,
      topic_id: initReqBody?.topic_id,
      type: initReqBody?.messageType,
      from: initReqBody?.from,
      assignee: initReqBody?.assignedTo,
      task_status: taskStatus,
      approval_status: initReqBody?.approval_status,
      due_date: initReqBody?.due_date,
      attachments:
        attachmentType == "youtube" ? attachment : initReqBody?.attachments,
      repeat_every: initReqBody?.repeat_every,
      repeat: initReqBody?.repeat,
      priority: initReqBody?.priority,
      due_time: initReqBody?.due_time,
      repeatable: initReqBody?.repeatable,
    };

    return {
      ...body,
      ...reqBody,
      thread_id: body?.thread_id || body?.id,
      message: msgEncrypter.encrypt(
        updateTaskApprovalMsg,
        process.env.REACT_APP_ENC_KEY,
        kuncikaR,
      ),
      from: {
        id: currentUserData?.id,
        name: `${currentUserData?.firstName} ${currentUserData?.lastName}`,
        pp: currentUserData?.profileImgUrl,
        target_subscriber_id: currentUserData?.activeSubscriber?.id,
        languageCode: currentUserData?.languageCode,
      },
      subscriber_id: currentUserData?.activeSubscriber?.id,
      temp_timetoken: `temp.${selectedGroup?.pnId}.${currentUserData?.id}.${
        Math.floor(new Date().getTime()) * 1000
      }`,
      thread_original_message: replyParentMsg?.id
        ? {
            id: replyParentMsg?.id,
            message: msgEncrypter.encrypt(
              replyParentMsg?.message,
              process.env.REACT_APP_ENC_KEY,
              kuncikaR,
            ),
            temp_timetoken: replyParentMsg?.temp_timetoken,
            timetoken: replyParentMsg?.timetoken,
            translations: msgEncrypter.encrypt(
              JSON.stringify(replyParentMsg?.translations),
              process.env.REACT_APP_ENC_KEY,
              kuncikaR,
            ),
          }
        : null,
    };
  };

  const handleUpdateTaskApproval = async (body) => {
    const initReqBody = {
      message: newMessages,
      group_subscriber_id: 0,
      topic_id: 0,
      messageType: 0,
      recipients: [],
      group_id: 0,
      assignedTo: null,
      task_status: 0,
      approval_status: 0,
      due_date: null,
      repeatable: false,
      repeat: null,
      repeat_every: null,
      priority: 1,
      due_time: null,
      attachments: [],
    };
    let newReqbody;
    const kuncikaR = generateRandomIV().toString();
    if (checkedType === "changeValues") {
      newReqbody = {
        ...body,
        thread_id: body?.thread_id ? body?.thread_id : body?.id,
        message: msgEncrypter.encrypt(
          updateTaskApprovalMsg,
          process.env.REACT_APP_ENC_KEY,
          kuncikaR,
        ),
        kuncika: kuncikaR,
        priority: priority,
        due_time: dueTime.format("HH:mm"),
        due_date: dueDate.format("YYYY-MM-DD"),
        from: {
          id: currentUserData?.id,
          name: `${currentUserData?.firstName} ${currentUserData?.lastName}`,
          pp: currentUserData?.profileImgUrl,
          target_subscriber_id: currentUserData?.activeSubscriber?.id,
          languageCode: currentUserData?.languageCode,
        },
        subscriber_id: currentUserData?.activeSubscriber?.id,
        temp_timetoken: `temp.${selectedGroup?.pnId}.${currentUserData?.id}.${
          Math.floor(new Date().getTime()) * 1000
        }`,
        thread_original_message: replyParentMsg?.id
          ? {
              id: replyParentMsg?.id,
              message: msgEncrypter.encrypt(
                replyParentMsg?.message,
                process.env.REACT_APP_ENC_KEY,
                kuncikaR,
              ),
              temp_timetoken: replyParentMsg?.temp_timetoken,
              timetoken: replyParentMsg?.timetoken,
              translations: msgEncrypter.encrypt(
                JSON.stringify(replyParentMsg?.translations),
                process.env.REACT_APP_ENC_KEY,
                kuncikaR,
              ),
            }
          : null,
      };
      // } else if (checkedType === "approveAndAskApproval") {
      //   console.log(reqBoby,"reqBoby")
      newReqbody = {
        ...body,
        thread_id: body?.thread_id ? body?.thread_id : body?.id,
        message: msgEncrypter.encrypt(
          updateTaskApprovalMsg,
          process.env.REACT_APP_ENC_KEY,
          kuncikaR,
        ),
        kuncika: kuncikaR,
        from: {
          id: currentUserData?.id,
          name: `${currentUserData?.firstName} ${currentUserData?.lastName}`,
          pp: currentUserData?.profileImgUrl,
          target_subscriber_id: currentUserData?.activeSubscriber?.id,
          languageCode: currentUserData?.languageCode,
        },
        subscriber_id: currentUserData?.activeSubscriber?.id,
        temp_timetoken: `temp.${selectedGroup?.pnId}.${currentUserData?.id}.${
          Math.floor(new Date().getTime()) * 1000
        }`,
        is_last: false,
        thread_original_message: replyParentMsg?.id
          ? {
              id: replyParentMsg?.id,
              message: msgEncrypter.encrypt(
                replyParentMsg?.message,
                process.env.REACT_APP_ENC_KEY,
                kuncikaR,
              ),
              temp_timetoken: replyParentMsg?.temp_timetoken,
              timetoken: replyParentMsg?.timetoken,
              translations: msgEncrypter.encrypt(
                JSON.stringify(replyParentMsg?.translations),
                process.env.REACT_APP_ENC_KEY,
                kuncikaR,
              ),
            }
          : null,
      };
    } else if (checkedType === "reassignTask") {
      handleTaskApprovalMsgLogic(initReqBody);

      newReqbody = buildTaskApprovalReqBody({
        initReqBody,
        taskStatus: initReqBody?.task_status,
        body,
        updateTaskApprovalMsg,
        kuncikaR,
      });
    } else {
      newReqbody = {
        ...body,
        thread_id: body?.thread_id ? body?.thread_id : body?.id,
        message: msgEncrypter.encrypt(
          updateTaskApprovalMsg,
          process.env.REACT_APP_ENC_KEY,
          kuncikaR,
        ),
        kuncika: kuncikaR,
        from: {
          id: currentUserData?.id,
          name: `${currentUserData?.firstName} ${currentUserData?.lastName}`,
          pp: currentUserData?.profileImgUrl,
          target_subscriber_id: currentUserData?.activeSubscriber?.id,
          languageCode: currentUserData?.languageCode,
        },
        subscriber_id: currentUserData?.activeSubscriber?.id,
        temp_timetoken: `temp.${selectedGroup?.pnId}.${currentUserData?.id}.${
          Math.floor(new Date().getTime()) * 1000
        }`,
        thread_original_message: replyParentMsg?.id
          ? {
              id: replyParentMsg?.id,
              message: msgEncrypter.encrypt(
                replyParentMsg?.message,
                process.env.REACT_APP_ENC_KEY,
                kuncikaR,
              ),
              temp_timetoken: replyParentMsg?.temp_timetoken,
              timetoken: replyParentMsg?.timetoken,
              translations: msgEncrypter.encrypt(
                JSON.stringify(replyParentMsg?.translations),
                process.env.REACT_APP_ENC_KEY,
                kuncikaR,
              ),
            }
          : null,
      };
    }
    const formData = new FormData();
    let responseFilesData = [];
    let fileDataPromises;
    let fileData;

    if (fileAttachment.length > 0) {
      fileDataPromises = fileAttachment.map((file) =>
        readFileAsDataURL(file.file),
      );
      fileData = await Promise.all(fileDataPromises);
      fileAttachment.forEach((file) => formData.append("files", file?.file));
    }

    // Save temporary message data first
    if (
      checkedType !== "approveAndAskApproval" &&
      checkedType !== "rejectAndAskApproval" &&
      checkedType !== "requestApprovalOnTask"
    ) {
      fileAttachment.length > 0
        ? dispatch(
            handleSaveTempMsgData(
              { ...newReqbody, fileData },
              selectedGroup?.pnId,
            ),
          )
        : dispatch(handleSaveTempMsgData(newReqbody, selectedGroup?.pnId));
    }

    // Upload files if online
    if (fileAttachment.length > 0 && navigator.onLine) {
      await dispatch(
        uploadAttachment(formData, selectedGroup?.pnId, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
            setProgress(percentCompleted);
          },
        }),
      ).then((res) => {
        responseFilesData = res;
        setProgress(0);
        setFileAttachment([]);
      });
    }

    // Update attachments in newReqbody with uploaded file data
    if (responseFilesData.length > 0) {
      newReqbody.attachments = responseFilesData;
    }
    if (navigator.onLine && updateTaskApprovalMsg && checkedType) {
      const updatedBody = {
        ...newReqbody,
        is_last:
          newReqbody?.type === MessageType.Approval && !newReqbody?.nhi_nhi
            ? true
            : false,
      };
      dispatch(handleTaskUpdate(updatedBody, body?.id)).then((response) => {
        if (response?.status === 200) {
          if (
            checkedType === "approveAndAskApproval" ||
            checkedType === "rejectAndAskApproval" ||
            checkedType === "requestApprovalOnTask"
          ) {
            // dispatch(handleGetThreadMessage(newReqbody)).then((res) => {
            setCurrentTaskData({});
            let msgBody = {};
            if (checkedType === "requestApprovalOnTask") {
              handleTaskApprovalMsgLogic(initReqBody);
              newReqbody = buildTaskApprovalReqBody({
                initReqBody,
                taskStatus: TaskStatus?.Done,
                body,
                updateTaskApprovalMsg,
                kuncikaR,
              });
               msgBody={
                 ...newReqbody,
               }
            } else {
              msgBody = {
                ...newReqbody,
                chain: body?.id,
              };
            }
            // });
            handleMessageSend(msgBody);
          }
        }
      });
    }
    if (checkedType !== "approveAndAskApproval") {
      handleResetState();
    }
  };

  const handleClickYouTube = () => {
    setAttachmentDrawer({
      ...attachmentdrawer,
      isYoutube: true,
    });
  };

  const handleCloseYoutubeDrawer = () => {
    setAttachmentDrawer({
      ...attachmentdrawer,
      isYoutube: false,
    });
  };

  const handleSendYouTubeAttachment = (videoData) => {
    const attachedLink = videoData?.map((item) => {
      return {
        thumbnail: item?.thumbnail,
        name: item?.title,
        location: item?.videoLink,
        id: item?.videoid,
      };
    });
    setAttachment(attachedLink);
    setAttachmenttype("serachedLinks");
    handleCloseYoutubeDrawer();
  };

  const handleClickGoogle = () => {
    setAttachmentDrawer({
      ...attachmentdrawer,
      isYoutube: false,
      isGoogle: true,
    });
  };

  const handleCloseGoogleDrawer = () => {
    setAttachmentDrawer({
      ...attachmentdrawer,
      isYoutube: false,
      isGoogle: false,
    });
  };

  const handleSendGoogleAttachment = (videoData) => {
    const attachedLink = videoData?.map((item) => {
      return {
        thumbnail: "",
        name: item?.title,
        location: item?.videoLink,
        id: item?.cacheId,
      };
    });
    setAttachment(attachedLink);
    setAttachmenttype("serachedLinks");
    handleCloseGoogleDrawer();
  };

  const handleBacktoMessage = () => {
    setNewMessages("");
    // dispatch(handleOpenCloseThreadView(false));
    dispatch({
      type: RECEIVED_THREAD_MESSAGES,
      payload: [],
    });
    setReplyParentMsg("");
    if (isThreadScreenFromTaskApprovalTab) {
      dispatch(handleHomeTabValue(isThreadScreenFromTaskApprovalTab));
      setIsThreadScreenFromTaskApprovalTab(null);
    } else {
      handleFetchMessages(groupList[0]?.pnId, selectedTopic?.id);
      dispatch(handleScrollToBottom(true));
    }
  };

  const handleDisablePrivateChat = async () => {
    const reqbody = {
      is_task_on: !isPrivateDisableChat,
      is_private_chat_on: !isPrivateDisableChat,
    };

    await dispatch(handleDeactivatePrivateChat(reqbody, selectedGroup?.id));

    setdisableprivatechat(false);
  };

  const handleReadStatusDrawer = () => {
    setReadstatusdrawer(true);
  };


  const handlecloseTeamlist = () => {
    setTaskButtonDrawer({ ...taskButtonDrawer, isOpen: false });
  };

  const handlecloseTopiclist = () => {
    setTaskButtonDrawer({ ...taskButtonDrawer, isOpen: false });
  };


  return {
    handleSearchInputChange,
    initialopenDialog,
    setOpenInitialDialog,
    isGroupmenuOpen,
    setGroupmenuOpen,
    setLanguageMenuOpen,
    isLanguageMenuOpen,
    setGroupMembermenu,
    isGroupmembermenu,
    setDeleteRequired,
    delrequired,
    setdeleteInputVal,
    delInputval,
    selectedGroup,
    // setselectedgroupmenu,
    // selectedgroupmenu,
    setDeletegroupmenu,
    isDeleteGroupmenu,
    setEditGroupmenu,
    isEditGroupmenu,
    setNotificationpreferenceModal,
    isNotificationpreferenceModalOpen,
    set24Hour,
    is24Hour,
    setDDMMYY,
    isDDMMYY,
    setMMDDYY,
    isMMDDYY,
    setYYMMDD,
    isYYMMDD,
    setDateFormate,
    dateFormate,
    setMediaFilesOpen,
    isMediaFilesOpen,
    setDatAndTimeModal,
    isdateAndTimeModalOpen,
    setAddpeopledarwer,
    isAddPeopledarwer,
    setownershipright,
    isownershipright,
    setPermissionModal,
    isPermissionModalOpen,
    setReadstatusdrawer,
    readStatusdrawer,
    setPrivateDisableChat,
    isPrivateDisableChat,
    setdisableprivatechat,
    isdisableprivatchat,
    setReplyParentMsg,
    replyParentMsg,
    setFileAttachment,
    fileAttachment,
    setAttachmentDrawer,
    attachmentdrawer,
    setSelectedAnswer,
    selecteAnswer,
    setShowStaredAiHistory,
    showStaredAiHistory,
    setShareAiText,
    isShareAiText,
    setShowTempQuery,
    showTempQuery,
    setTempAiQuery,
    tempAiQuery,
    setAiQueryValue,
    aiQueryValue,
    setTaskButtonDrawer,
    taskButtonDrawer,
    selectRecipientsDrawerOpen,
    setSelectRecipientsDrawerOpen,
    externalGroupMember,
    setExternalGroupMemebr,
    setAttachment,
    attachment,
    setMessageType,
    msgType,
    isEmailChecked,
    isMobileChecked,
    setEmailChecked,
    setMobileChecked,
    selectedRecipients,
    setSelectedRecipients,
    taskAssignedUser,
    setTaskAssignedUser,
    dueTime,
    setDueTime,
    dueDate,
    setDueDate,
    priority,
    setPriority,
    isRepeat,
    setRepeat,
    repeatType,
    setRepeatType,
    selecteRepeatEvery,
    setSelectedRepeatEvery,
    searchInputValue,
    setSearchInputValue,
    filteredMessageList,
    isSearching,
    highlightText,
    stepper,
    setStepper,
    taskData,
    setTaskData,
    isTaskUpdateOpen,
    setTaskUpdateOpen,
    updateTaskApprovalMsg,
    setUpdateTaskApprovalMsg,
    checkedType,
    setCheckedType,
    progress,
    groupList,
    currentUserData,
    isTaskTypeModalOpen,
    setIsTaskTypeModalOpen,
    isThreadTaskTypeModalOpen,
    setIsThreadTaskTypeModalOpen,
    setThreadOpen,
    isThreadOpen,
    isSubTaskSuggestionDrawerOpen,
    setSubTaskSuggestionDrawerOpen,
    handleLanguageCloseMenu,
    handleCloseGroupMenu,
    handleOpenGroupDrawer,
    handleCloseUserChatAttach,
    handleclickAttherate,
    handleChange,
    handleCloseMemberDrawer,
    handleSelectedGroupmenu,
    handleSelectedGroupmenuClick,
    handleCloseInitialDialog,
    handleMessageSend,
    handleSendTempMsg,
    handleUpdateTaskApproval,
    handleNotificationPreference,
    handleDateTimeUpdate,
    handleCloseAddPeopleDrawer,
    handleClickTaskUpdate,
    handleViewThreadClickTaskApprovalTab,
    handleAddgroupMember,
    handleUpdateGroupname,
    handleDeleteGroup,
    handleOnDeleteInput,
    handleOnInputChange,
    handleOnChangeNewMessage,
    handlecloseTeamlist,
    handlecloseTopiclist,
    handleReadStatusDrawer,
    handleDisablePrivateChat,
    handleBacktoMessage,
    handlegetThreadMessages,
    handleSendGoogleAttachment,
    handleCloseGoogleDrawer,
    handleClickGoogle,
    handleSendYouTubeAttachment,
    handleCloseYoutubeDrawer,
    handleClickYouTube,
    setTaskModalDeatils,
    taskModalDeatils,
    isSearchGroupInfoOpen,
    setIsSearchGroupInfoOpen,
    handleSearch,
    leaveCompleteTask,
    setLeaveCompleteTask,
    isTaskUpdateTypeModalOpen,
    setIsTaskUpdateTypeModalOpen,
  };
};

export default useTabState;
